import { isEmpty, isEqual, isString } from "lodash";

 const reduceValidators = ({ value, validatorFuncs, errorsMsgs }) => {
  const validate = validatorFuncs.reduce(
    (acc, func, index) => {
      if (acc.isValid) {
        const values = Array.isArray(value) ? value : [value];
        const isValid = func.apply(null, values);
        if (!isValid) {
          return {
            isValid: false,
            errorMsg: errorsMsgs[index],
          };
        } else {
          return acc;
        }
      } else {
        // doing AND operation
        return acc;
      }
    },
    { errorMsg: "", isValid: true }
  );
  return validate;
};
 const isFieldNotEmpty = (value) =>
  typeof value === "number" ? value : !isEmpty(value);

 const areValuesNotEqual = (value1, value2) => !isEqual(value1, value2);

 const isPhoneNumber = (value) => {
  const digitsRegex = new RegExp(/^\d+$/gi); //eslint-disable-line
  return digitsRegex.test(value);
};
 const isEmail = (value) => {
  const emailRegex = new RegExp(
    /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/ //eslint-disable-line
  );
  return emailRegex.test(value);
};
 const isNegativeNumber = (value) => value < 0;
 const getBoolean = (value) =>
  isString(value) ? value === "true" : value;

export default {
  reduceValidators,
  isFieldNotEmpty,
  areValuesNotEqual,
  isPhoneNumber,
  isEmail,
  isNegativeNumber,
  getBoolean,
};
